import { Fragment } from "react"

// A standalone integer inside a headline is set at display scale, so the sentence
// carries the number the way the reference does — "lo pagas en 4 pedazos" with the
// 4 nearly twice the height of the words around it.
const NUMERAL = /^\d+$/

export const HeadingNumeral = ({ children }: { children: string }) => (
  <>
    {children.split(" ").map((word, index) => (
      <Fragment key={`${word}-${index}`}>
        {index > 0 ? " " : null}
        {NUMERAL.test(word) ? <span className="text-display-2xl @2xl:text-display-hero align-baseline font-black">{word}</span> : word}
      </Fragment>
    ))}
  </>
)
